export default __webpack_public_path__ + "static/media/lock.89c41530.svg";